export type SpacerProps = {
	height: string;
};

export const Spacer = ({height}: SpacerProps) => <div style={{height}} />;
